<template>
    <div v-if="documents && documents.length" class="mb-4 mr-6">
        <div v-for="doc in documents" :key="doc.id" class="document columns is-mobile is-gapless">
            <div class="column is-narrow">
                <i class="far fa-file fa-fw mr-2"></i>
            </div>
            <div class="column">
                <div class="has-text-weight-bold">
                    {{doc.subject}}
                    <span class="staff-label ml-2" v-if="!isPublished(doc)"><i class="far fa-eye-slash mr-1"></i>Staff</span>
                </div>
                <div v-if="doc.id_number">{{doc.id_number}}</div>
                <div v-if="doc.information" class="mt-2">{{doc.information}}</div>
            </div>
            <div class="column is-narrow">
                <b-button type="is-primary is-outlined is-small" @click.stop="view(doc)"><i class="fas fa-eye mr-2"></i>View</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {url} from "../http_client";
    import {mapGetters} from "vuex";

    // Documents hanging off an itinerary event, whether they came from the trip event
    // or were added for this participant. Staff registrations also receive documents
    // that are not published to participants (same rule as vendor info) — those are
    // labelled so a trip leader knows not to read them out to the group.
    export default {
        name: "EventDocuments",
        props: {
            documents: {
                required: false
            }
        },
        data: function() {
            return {
                apiUrl: url
            }
        },
        computed: {
            ...mapGetters(['registration', 'token'])
        },
        methods: {
            isPublished: function(doc) {
                return !!Number(doc.is_app_visible);
            },
            view: function(doc) {
                // Opens in a new tab, so the token goes in the query string rather than
                // an Authorization header. The API checks the file belongs to a trip this
                // registration is on before serving it.
                window.open(`${this.apiUrl}app/registrations/${this.registration.id}/documents/file/${doc.file}?auth=${this.token}`, '_blank');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .document {
        font-size: 0.85rem;
        border-left: 2px #628b21 solid;
        padding: 0.6rem 0.6rem 0.6rem 8px;
        background: rgba(244, 244, 244, 0.86);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;

        i.fa-file {
            color: #628b21;
            font-size: 1.1rem;
        }
    }

    .staff-label {
        font-size: 0.7rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: #628b21;
        white-space: nowrap;
    }
</style>
